module.exports = __webpack_public_path__ + "2a8dfea4d633a4017bf6aa0ce0ce7c9e.fbx";